<template>
  <div>
    <v-row>
      <v-col style="padding: 2%">
        <v-col cols="12" sm="12" md="3">
          <div class="button-container">
            <v-btn
              @click="goToPage('/AddTemplate')"
              class="white--text"
              style="padding: 10px 20px; margin-bottom: 16px;"
            >
              Add Property
            </v-btn>
          </div>
        </v-col>

        <br>
        <v-row style="padding: 1%">
          <v-col cols="12" sm="12" md="3">
            <v-text-field
              placeholder="Search Template"
              v-model="search"
              class="field"
              append-outer-icon="mdi-magnify"
              :search="search"
              height="10"
              style="padding-right: 12px"
              solo
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-select
              @change="getCategories"
              flat
              v-model="sortBy"
              solo
              class="field"
              append-outer-icon="mdi-menu-down"
              hide-details
              :items="sortOptions"
              label="Sort By..."
              style="padding-right: 12px"
            ></v-select>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    
    <!-- Display fetched templates -->
    <v-row>
  <v-col v-for="(category, index) in categories" :key="index" cols="12" sm="6" md="4">
    <v-card @click="viewCategory(category)" class="template-card d-flex flex-column align-center">
      <v-img :src="category.imageUrl || 'placeholder_image_url_here'" height="150" width="150"  class="image-container">
      </v-img>
      <v-card-title class="text-center">{{ category.name }}</v-card-title>
    </v-card> 
  </v-col>
</v-row>
  </div>
</template>

<script>
import { collection, getDocs, getFirestore } from "firebase/firestore";
import { firebaseApp } from "../firebaseConfig";

const db = getFirestore(firebaseApp);

export default {
  name: "App",
  data() {
    return {
      search: "",
      sortBy: "", // Sorting option selected by the user
      sortOptions: ["Default", "Name", "Date"], // Sorting options for the dropdown
      categories: [] // Array to store fetched templates
    };
  },
  methods: {
    async getCategories() {
      try {
        let querySnapshot;
        if (this.sortBy === "Name") {
          querySnapshot = await getDocs(collection(db, "Category").orderBy("name"));
        } else if (this.sortBy === "Date") {
          querySnapshot = await getDocs(collection(db, "Category").orderBy("createdAt"));
        } else {
          querySnapshot = await getDocs(collection(db, "Category"));
        }
        const categories = querySnapshot.docs.map(doc => {
      
          const data = doc.data();
          data.imageUrl = data.imageUrl || null;
          data.id = doc.id;
       
          return data;
        });
        this.categories = categories;
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },
    viewCategory(category) {
      this.$router.push({ name: 'viewTemplateDetails', params: {selectedId : category.id ,catName : category.name} });

    },
    goToPage(path) {
      this.$router.push({ path });
    }
  },
  created() {
    this.getCategories(); // Fetch templates when the component is created
  }
};
</script>

<style scoped>
.v-input input {
  height: 10px;
}
.text-start {
  background-color: #4b4b4b;
}
.v-text-field {
  border: 1px solid black;
  height: 50px;
}
.white--text {
  background: rgb(23, 74, 133);
  background: linear-gradient(
    rgba(0,129,128,255) 0%,
    rgba(0,129,128,255) 100%
  );
  border-radius: 20px;
  width: 100%;
}
.field {
  height: 50px;
  background: #00d200;
}

.card-content {
  color: rgb(7, 4, 4);
  padding: 10px;
  width: 100;
  box-sizing: border-box;
  text-align: center;
}

</style>
